import { render, staticRenderFns } from "./DispatchNoteOrderItems.vue?vue&type=template&id=3937113b&scoped=true&"
import script from "./DispatchNoteOrderItems.vue?vue&type=script&lang=js&"
export * from "./DispatchNoteOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./DispatchNoteOrderItems.vue?vue&type=style&index=0&id=3937113b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937113b",
  null
  
)

export default component.exports